import type { GetCustomerBalanceRequest, GetTransactionHistoryRequest, GetLoyaltyPolicyRequest } from './types';

export const LOYALTY_QUERY_KEYS = {
  default: () => ['loyalty'] as const,
  getCustomerBalance: ({ customerId }: GetCustomerBalanceRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'balance', customerId] as const,
  getTransactionHistory: ({ customerId, limit, lastEvaluatedKey }: GetTransactionHistoryRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'transactions', customerId, limit, lastEvaluatedKey] as const,
  getLoyaltyPolicy: ({ currency }: GetLoyaltyPolicyRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'policy', currency] as const,
};
